export default "__VITE_ASSET__Blp44xaZ__"